import { UmbTableTreeViewElement } from './table-tree-view.element.js';
import type { UmbExtensionManifestKind } from '@umbraco-cms/backoffice/extension-registry';

export const manifests: Array<UmbExtensionManifest | UmbExtensionManifestKind> = [
	{
		type: 'kind',
		alias: 'Umb.Kind.TreeView.Table',
		matchKind: 'table',
		matchType: 'treeView',
		manifest: {
			type: 'treeView',
			element: UmbTableTreeViewElement,
			weight: 900,
			meta: {
				label: '#tree_tableViewLabel',
				icon: 'icon-table',
			},
		},
	},
];
